/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-09 23:38:44
 */

import OperationLog from '../operationLog';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import OperationLogApi, { OperationLogDOI } from '../api/operationLogApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import EnumLogType from 'src/enums/enumLogType';
import EnumDivisor from 'src/enums/enumDivisor';
import EnumEntity from 'src/enums/enumEntity';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import FileUtil from 'src/util/fileUtil';

export default class OperationLogService extends ListPageService {
    ctx: OperationLog;

    constructor(ctx: OperationLog) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '时间',
                field: 'datatime',
                minWidth: 170,
            },
            {
                headerName: '组分',
                field: 'PolId',
                minWidth: 170,
                cellRenderer(params) {
                    let data = params.data;
                    return EnumDivisor.findCode(data.PolId).getName();  
                }
            },
            {
                headerName: '日志类型',
                field: 'log_type',
                minWidth: 100,
                cellRenderer(params) {
                    let data = params.data;
                    return EnumLogType.findId(data.log_type).getName();
                },
            },
            {
                headerName: '日志内容',
                field: 'log_content',
                minWidth: 190,
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '组分',
                labelWidth: 60,
                width: 160,
                field: 'component',
                props: { value: null, type: EnumEntity.Component.getId(), searchParams: { mn: this.ctx.$route.query.mn } },
            },
            {
                component: CommonSelect,
                label: '日志类型',
                field: 'log_type',
                labelWidth: 60,
                width: 160,
                props: { value: '', dataSource: EnumLogType.getList() },
            },

            {
                component: DatePicker,
                label: '时间',
                labelWidth: 60,
                width: 250,
                field: 'time',
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: {
                    value: DateTimeUtil.getDayInterval(7),
                    type: 'daterange',
                    options: {
                        shortcuts: [
                            {
                                text: '最近1天',
                                value() {
                                    return DateTimeUtil.getDayInterval(1);
                                },
                            },
                            {
                                text: '最近7天',
                                value() {
                                    return DateTimeUtil.getDayInterval(7);
                                },
                            },
                            {
                                text: '最近30天',
                                value() {
                                    return DateTimeUtil.getDayInterval(30);
                                },
                            },
                        ],
                    },
                    placeholder: '请选择时间',
                },
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '导出',
                type: 'info',
                async onClick() {
                    let { code, data } = await OperationLogApi.exportAll(
                        t.ctx.queryForm.getQueryObj<OperationLogDOI.QueryRowDataParamsI>(),
                    );
                    if (code === 0) {
                        FileUtil.download(data.download_url);
                    }
                },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<OperationLogDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await OperationLogApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
            mn: this.ctx.$route.query.mn,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
